<template>
	<v-layout v-if="!dataSame && contestId">
		<v-flex xs6>
			<old-version-marker/>
			<agency-choose-beneficiaries
				:readonly="true"
				:value="old"
			/>
		</v-flex>
		<v-flex xs6>
			<new-version-marker/>
			<agency-choose-beneficiaries
				:readonly="true"
				:value="current"
			/>
		</v-flex>
	</v-layout>
</template>

<script>
	import OldVersionMarker from "../../offer/compareComponents/oldVersionMarker";
	import NewVersionMarker from "../../offer/compareComponents/NewVersionMarker";
	import AgencyChooseBeneficiaries from "../../agencyContest/components/AgencyChooseBeneficiaries";

	export default {
		name: "AgencyCompareBeneficiaries",
		components: {AgencyChooseBeneficiaries, NewVersionMarker, OldVersionMarker},
		computed: {
			dataSame () {
				let comparisonResult = JSON.stringify(this.old) === JSON.stringify(this.current);
				if (comparisonResult === false) {
					this.$emit('dataDiffer', true);
				}
				return comparisonResult;
			}
		},

		props: {
			old: {},
			current: {},
			contestId: {},
		}
	};
</script>

<style scoped>

</style>
